var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentStatus)?_c('div',{staticClass:"status-progress"},_vm._l((_vm.statuses),function(status){return _c('div',{staticClass:"status-progress__item"},[_c('div',{staticClass:"status-progress__item-dot",class:{active: status.active}}),_c('div',{staticClass:"status-progress__item-label"},[_vm._v(_vm._s(status.title))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }